/**
 * Check if a key/val exist in an object
 * Uses the string format: obj.key.key.key
 * src: https://stackoverflow.com/questions/23808928/javascript-elegant-way-to-check-nested-object-properties-for-null-undefined
 *
 * @param obj
 * @param key
 * @returns {*}
 */
const hasObj = function (obj, key) {
  return key.split('.').every(function (x) {
    if (typeof obj !== 'object' || obj === null || !(x in obj)) {
      return false
    }

    obj = obj[x]
    return true
  })
}

export default hasObj



// WEBPACK FOOTER //
// ./src/functions/hasObj.js